var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAbbyCare = function SvgAbbyCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#002D5D",
    clipPath: "url(#abby-care_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.413 1.04a.547.547 0 0 0-.021-.011c-1.848-.917-3.762-.637-5.534.81a9.562 9.562 0 0 0-2.03 2.349.699.699 0 0 0-.094.35v8.255c0 .235.12.454.318.586a.728.728 0 0 0 .671.07 35.978 35.978 0 0 0 3.715-1.777c2.66-1.469 4.354-2.902 5.03-4.257 1.444-2.856-.332-5.447-2.055-6.375ZM8.14 1.839C6.368.392 4.455.11 2.606 1.029a.742.742 0 0 0-.021.01C.863 1.969-.914 4.56.529 7.413c.678 1.357 2.37 2.791 5.032 4.26a35.976 35.976 0 0 0 3.714 1.776.729.729 0 0 0 .672-.07.704.704 0 0 0 .317-.586V4.537a.698.698 0 0 0-.094-.35A9.562 9.562 0 0 0 8.14 1.84Zm.685 9.877C6.582 10.71 2.77 8.69 1.82 6.785c-1.113-2.2.487-3.976 1.446-4.499 1.303-.641 2.624-.433 3.927.62.833.672 1.414 1.497 1.632 1.83v6.98Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "abby-care_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-.001.5h21.999v13H-.001z"
  })))));
};
export default SvgAbbyCare;